import http from "../utils/http-common";

class KaskoDataService {
  getAll() {
    return http.get("/kasko");
  }

  getAllActive() {
    return http.get("/kasko/active");
  }

  getByValidFrom(valid_from) {
    return http.get(`/kasko/${valid_from}`);
  }

  get(id) {
    return http.get(`/kasko/id/${id}`);
  }

  create(data) {
    return http.post("/kasko", data);
  }

  update(valid_from, data) {
    return http.put(`/kasko/${valid_from}`, data);
  }

  delete(id) {
    return http.delete(`/kasko/${id}`);
  }

  deleteByValidFrom(valid_from) {
    return http.delete(`/kasko/by-date/${valid_from}`);
  }
}

export default new KaskoDataService();
